import { CommonModule } from '@angular/common'
import { Component, inject, input, OnDestroy, output, signal, Type } from '@angular/core'
import { DialogService, IDialogParameters } from '@corporate-tailwind/modal'

export interface ICorpDialogConfig {
    title?: string
    width?: string
    height?: string
    showCloseButton?: boolean
    closeOnBackdropClick?: boolean
    closeOnEscapeKey?: boolean
}

@Component({
    selector: 'corp-dialog',
    standalone: true,
    imports: [CommonModule],
    template: ``
})
export class CorpDialogComponent implements OnDestroy {
    config = input<ICorpDialogConfig>({})
    readonly closed = output<void>()

    readonly isOpen = signal(false)

    readonly #dialogService = inject(DialogService)

    open<T>(componentType: Type<T>, data?: any): void {
        const cfg = this.config()

        const parameters: IDialogParameters = {
            arguments: {
                title: cfg.title ?? '',
                width: cfg.width ?? '800px',
                height: cfg.height ?? '600px'
            },
            showCloseButton: cfg.showCloseButton ?? true,
            closeOnBackdropClick: cfg.closeOnBackdropClick ?? true,
            closeOnEscapeKey: cfg.closeOnEscapeKey ?? true,
            data
        }

        void this.#dialogService.open(componentType, data, parameters)
        this.isOpen.set(true)
    }

    close(): void {
        void this.#dialogService.close().then(() => {
            this.isOpen.set(false)
            this.closed.emit()
        })
    }

    ngOnDestroy(): void {
        if (this.isOpen()) {
            void this.#dialogService.close()
        }
    }
}
